<template>
  <v-col cols="12">
    <v-list class="py-0 receiver-list" dense>
      <v-list-item class="title-element px-2 font-weight-medium" :selectable="false" exact-active-class="title-element">
        <v-row no-gutters>
          <v-col cols="5" class="text-left pl-4"> {{ $i18n.t('sidebar.receiver') }}</v-col>
          <v-col cols="5"> {{ $i18n.t('sidebar.pattern') }}</v-col>
        </v-row>
      </v-list-item>
      <v-list-item
        v-for="item in receivers"
        :key="item.id"
        class="list-element hover-list-element px-2"
        :ripple="false"
      >
        <v-list-item-content>
          <v-row no-gutters style="align-items: center" class="justify-space-between">
            <v-col cols="5" class="text-left pl-4 text-break">
              {{ item.recipient }}
            </v-col>
            <v-col cols="5" class="text-break">
              {{ item.pattern_name }}
            </v-col>
            <v-col cols="2">
              <dots-menu
                @delete="deleteItem(item.id)"
                @edit="editItem(item.id)"
                :items="dotsItems"
                font-size="19px"
              ></dots-menu>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-col>
</template>

<script>
import DotsMenu from '@/components/DotsMenu';
export default {
  name: 'ReceiversList',
  components: { DotsMenu },
  props: {
    receivers: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    dotsItems: [{ name: 'edit' }, { name: 'delete' }],
  }),
  methods: {
    deleteItem(id) {
      this.$emit('deleteReceiver', id);
    },
    editItem(id) {
      this.$emit('editReceiver', id);
    },
  },
};
</script>

<style scoped lang="scss">
.list-element {
  @include border(bottom);
}
.title-element {
  @include border(bottom);
}
.receiver-list {
  border-radius: 4px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25), 0px -1px 0px rgba(0, 0, 0, 0.15) !important;
}
</style>
